import * as CSS from 'csstype';
import React from 'react';
import { DefaultTheme } from 'styled-components/macro';
import { SDXThemeColors } from '@sdxcorp/sdx-dds-gui-lib';

export type CSSPropertyNames = keyof CSS.StandardLonghandPropertiesHyphen | 'fill' | 'all' | 'padding' | 'border-color';
export const defaultTransition = (...cssprop: CSSPropertyNames[]) => cssprop.map(property => `${property} 0.15s ease-in`).join(',');

export const colorValue = <T>(theme: DefaultTheme, cb: (colors: SDXThemeColors) => T): T => cb(theme.global.colors);

export const onMouseUpDownBlurring = (event: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement>) => {
  event.preventDefault();
  event.currentTarget.blur();
};

export type ColorSpec = keyof SDXThemeColors | { dark: keyof SDXThemeColors; light: keyof SDXThemeColors };
// Adapted from https://github.com/grommet/grommet/blob/master/src/js/utils/colors.js
// TODO: Improve typing system
export const normalizeColor = (color: ColorSpec, theme: DefaultTheme & { dark?: boolean }) => {
  type sdxColors = keyof SDXThemeColors;
  let colorSpec;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const anyColor = color as any;
  if (typeof anyColor !== 'string' && 'dark' in anyColor) {
    colorSpec = {
      dark: theme.global.colors[anyColor.dark as sdxColors],
      light: theme.global.colors[anyColor.light as sdxColors],
    };
  } else {
    colorSpec = theme.global.colors[color as sdxColors];
  }
  // If the color has a light or dark object, use that
  let result = colorSpec;
  if (colorSpec) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const colSpec = colorSpec as any;
    if (theme.dark && typeof colSpec !== 'string' && 'dark' in colSpec) {
      result = colSpec.dark;
    } else if (!theme.dark && typeof colSpec !== 'string' && 'light' in colSpec) {
      result = colSpec.light;
    }
  }

  return result;
};
